import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    BBBreachRiskSubscriptionBadge,
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {Box, Card, Grid} from "@material-ui/core";
import {
    disableBRSocialTestsAuthorized,
    enableBRSocialTestsAuthorized
} from "../../../actions";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Fab from "@material-ui/core/Fab";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import PlayArrowSharpIcon from "@material-ui/icons/PlayArrowSharp";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Badge} from "reactstrap";
import IntlMessages from "../../../util/IntlMessages";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";

const BRSocialEngineeringAuthorizationWidget = ({
                                                    brSubscriptionRequired="Premium",
                                                    overrideEnabledForAdminsStaff = false,
                                                })=> {

    const {customerInView, customers, } = useSelector(({customer})=> customer);
    const {entityInView, portfolios, loadingPortfolios, loadingUpdateBRSocialTestsAuthorized, loadingUpdateBRSocialTestsAuthorizedError} = useSelector(({breachrisk})=> breachrisk);
    const {authUser} = useSelector(({auth})=>auth);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    const customerIdToUse = customers? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const ownershipVerified = myEntity && myEntity.onboarding_progress && myEntity.onboarding_progress.verified_ownership;

    const isCorrectSubscriptionLevel = myEntity ? myEntity.active_subscription && myEntity.premium_subscription : null;
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const shouldAllowEnabling = (overrideEnabledForAdminsStaff && isAdminStaff)
        ? true
        : !!(brSubscriptionRequired
            && ownershipVerified
            && isCorrectSubscriptionLevel);

    const [customer, setCustomer] = useState(customers ? customers[customerIdToUse] : null);
    const [isBRSocialTestsAuthorized, setIsBRSocialTestsAuthorized] = useState(myEntity && myEntity.settings ? myEntity.settings.social_testing_authorized : null);

    console.log("BRSocialEngineeringAuthorizationWidget", "myEntity", myEntity, "ownershipVerified", ownershipVerified, "brSubscriptionRequired", brSubscriptionRequired, "isCorrectSubscriptionLevel", isCorrectSubscriptionLevel, "isAdministratorForEntity", isAdministratorForThisEntity, "shouldAllowEnabling", shouldAllowEnabling);



    const dispatch = useDispatch();

    useEffect(() => {
        // console.log("Br authorize attacks control button. customers", customers, "customerIdToUse", customerIdToUse, "customer", customer, "loadingPortfolios", loadingPortfolios, "portfolios", portfolios, "myEntity", myEntity, "isBRAttacksAuthorized", isBRAttacksAuthorized)
        if (customers && customerIdToUse) {
            //setLoading(false);

            setCustomer(customers[customerIdToUse]);
            if (customer) {
                setIsBRSocialTestsAuthorized(myEntity && myEntity.settings ? myEntity.settings.social_testing_authorized : null);
            }

        }
    }, [customer, isBRSocialTestsAuthorized, customerIdToUse, customers, portfolios, loadingPortfolios, myEntity]);

    const handleButtonClick = (event) => {
        if (!loadingUpdateBRSocialTestsAuthorized[entityInView]) {

            if (customer) {
                if (isBRSocialTestsAuthorized) {
                    console.log("disabling social tests for", customerIdToUse, entityInView)
                    dispatch(disableBRSocialTestsAuthorized({
                        customerId: customerIdToUse,
                        entityId: entityInView
                    }));
                } else {
                    console.log("enabling social tests for", customerIdToUse, entityInView)
                    dispatch(enableBRSocialTestsAuthorized({
                        customerId: customerIdToUse,
                        entityId: entityInView
                    }));
                }
            }
        }
    };


    const buttonClassname = () => {
        if (!isBRSocialTestsAuthorized && customers && !loadingUpdateBRSocialTestsAuthorized[entityInView]) {
            return "bg-bb-risk-medium text-dark"
        } else if (isBRSocialTestsAuthorized && customers && !loadingUpdateBRSocialTestsAuthorized[entityInView]) {
            return "bg-bb-risk-lowest text-white"
        } else {
            return "bg-light text-dark"
        }
    };

    return ( <div className={'mb-3'}>

            <Card className={`pt-2 bg-light animated fadeIn animation-duration-5 d-flex flex-row`} style={{borderLeft: "12px solid gray", padding: "3px", paddingTop: "7px", display:"flex"}}>

                <Grid container
                      spacing={0}
                      alignItems="stretch"
                      justifyContent="center"
                      direction="row"
                >
                    <Grid item xs={4}>

                        <Box className={"m-2"} style={{position: "relative", alignItems:"center"}}>
                            <BBDisableChildren
                                isDisabled={shouldAllowEnabling}
                                // brLevelRequired={"infoLevel3"}
                                brSubscriptionRequired = {brSubscriptionRequired ? brSubscriptionRequired : null}
                                ownershipVerified={ownershipVerified}
                                isCompact
                                isButtonSized
                            >
                                <Tooltip title={isBRSocialTestsAuthorized ? "Disable Social Engineering" : "Enable Social Engineering"}>
                                    <Fab color="default"
                                         id={"socialTestingButton"}
                                         style={{ position: "absolute", top: "-6", left: "-6"}}
                                         className={buttonClassname()}
                                         onClick={(event) => handleButtonClick(event)}>
                                        {isBRSocialTestsAuthorized ? <StopSharpIcon/> : <PlayArrowSharpIcon/>}
                                    </Fab>
                                </Tooltip>
                                {(loadingPortfolios[customerIdToUse] || !customers) && <CircularProgress size={67} style={{color:"green", position: "absolute", top: "-6", left: "-6", zIndex: "1"}} />}
                            </BBDisableChildren>
                        </Box>

                        {/*<h5 style={{fontSize: "smaller"}}>Control:</h5>*/}
                    </Grid>
                    <Grid item xs={8} >
                        <h2 >Social Engineering</h2>
                        <Box >Status: {(customer &&  !loadingPortfolios[customerIdToUse])
                            ? isBRSocialTestsAuthorized
                                ? <Badge id={"socialTestingBadge"} color="bb-risk-lowest"><IntlMessages id={"badge.cirt.active"}/></Badge>
                                : <Badge id={"socialTestingBadge"} color="bb-risk-medium"><IntlMessages id={"badge.cirt.inactive"}/></Badge>
                            : <small> <em>Retrieving...</em></small>
                        }</Box>

                    </Grid>
                </Grid>
                <div style={{marginLeft: "auto", marginTop: "-4px", marginRight: "3px"}}>
                    <BBBreachRiskSubscriptionBadge subscriptionLevel={"Premium"} />
                    {/*<Tooltip title={`This is a premium feature.`}>*/}
                    {/*          <span>*/}
                    {/*            <Badge*/}
                    {/*                color={"bg-geek-blue"}*/}
                    {/*                className={"p-1 m-0 badge-geekblue"}*/}
                    {/*            >Premium</Badge>*/}
                    {/*          </span>*/}
                    {/*</Tooltip>*/}
                </div>
                <div style={{marginLeft: "auto", marginTop: "-2px"}}>
                    <Tooltip title={"BreachRisk™ Social brings our powerful precision phishing engine from our CIRT™ service into BreachRisk™."}>
                        <InfoSharpIcon style={{fontSize: "20px",}} className={`text-muted`}/>
                    </Tooltip>
                </div>

            </Card>

        </div>
    );

}
export default BRSocialEngineeringAuthorizationWidget;